import type { Meta, StoryFn } from '@storybook/react';
import type { SpinnerProps } from './Spinner';

import { Spinner } from './Spinner';

const codeString = '<Spinner ariaValueText={ariaValueText} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Spinner',
  component: Spinner,
  argTypes: {
    ariaValueText: {
      control: 'text',
    },
    showAfterMs: {
      control: 'number',
    },
  },
  parameters: {
    inspectComponent: Spinner,
    codeString: codeString,
  },
} as Meta<SpinnerProps>;

const Template: StoryFn<SpinnerProps> = (args) => <Spinner {...args} />;

export const SpinnerExample = Template.bind({});
SpinnerExample.args = {
  ariaValueText: 'Example value text',
  showAfterMs: 250,
};
